import React, { useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/system';
import PersonalProfile from '../OrganizationProfile/OrganizationProfile';
import './organizationFormUser.css'
import RichText from '../richText/richText';
import OrganizationStaff from '../organizationStaff/organizationStaff'
import OrganizationStudy from '../../pages/oganizationStudy/orgnaizationStudy'
import SinglePdfViewer from '../UserDocuments/userDocuments';
import UserContext from '../../Context/User/userContext.jsx';
import axios from 'axios';

const StyledTab = styled(Tab)({
    fontSize: '1.1rem',
    fontWeight: '600', // Increased label size
    color: '#008B8B', // Default color
    '&:hover': {
        color: '#169a8f', // Change color to yellow on hover
    },
    '&.Mui-selected': {
        color: '#169a8f', // Change color to blue for the active tab
    },
    paddingLeft: '10px',
    marginRight: '50px', // Add spacing between tabs
    fontFamily:'nunito'
});

const StyledTabList = styled(TabList)({
    background: '#E0F2F1', /* Fallback for old browsers */
    background: '-webkit-linear-gradient(to left, #B2DFDB, #E0F2F1)', /* Chrome 10-25, Safari 5.1-6 */
    background: 'linear-gradient(to left, #B2DFDB, #E0F2F1)', /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    backgroundColor: '#ffffff', // Background color
    color: '#169a8f',
    display: 'flex', // Flexbox display
    justifyContent: 'around', // Centering tabs
    alignItems: 'center' // Aligning items vertically
});

function OrganizationFormUser({ setShowSpinner }) {
    const handleOpenPdf = () => {
        window.open(userObj?.signedDocument, '_blank');
    };
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [adminExist, setAdminExist] = useState(false)

    // Bearer Token
    const { user, setUser } = useContext(UserContext);
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";
    const userObj = user && (typeof user === 'string' ? JSON.parse(user) : user);
    const userName = userObj && (userObj?.firstName + ' ' + userObj?.lastName).toUpperCase();
    const _id = userObj && userObj._id;

    const checkForAdmin = async () => {
        try {
            const response = await axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/validateAdmin/${_id}`, {
                headers: {
                    'Authorization': `Bearer ${tokenValue}`
                    // You can add other headers if needed like authorization token, etc.
                }
            });

            // Determine if the user is an admin based on the API response
            setAdminExist(response.data.success);
        } catch (error) {
            console.error("Error:", error.response?.data?.message || error.message);
            setAdminExist(false); // Return false in case of an error
        }
    };

    useEffect(() => {
        if (user) {
            checkForAdmin()
        }
    }, [user])

    return (
        <div className='p-4'>
            <h4 style={{color:'rgb(23 131 131)'}}>{userName}</h4>
            <div className='mt-3'>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <StyledTabList onChange={handleChange} aria-label="lab API tabs example">
                                <StyledTab label="Organization" value="1" />
                                <StyledTab label="Staff" value="2" />
                                {!adminExist && <StyledTab label="Documents" value="3" />}
                                <StyledTab label="Studies" value="4" />
                                <StyledTab label="Facilities" value="5" />
                            </StyledTabList>
                        </Box>
                        <TabPanel value="1">
                            <PersonalProfile setShowSpinner={setShowSpinner} />
                        </TabPanel>
                        <TabPanel value="2"><OrganizationStaff setShowSpinner={setShowSpinner} /></TabPanel>
                        {!adminExist && (
                            <TabPanel
                                value="3"
                                onClick={handleOpenPdf} // Add the click handler here
                            >
                                <SinglePdfViewer setShowSpinner={setShowSpinner} url={userObj ? userObj.signedDocument : null} />
                            </TabPanel>
                        )}
                        <TabPanel value="4"><OrganizationStudy setShowSpinner={setShowSpinner} /></TabPanel>
                        <TabPanel value="5"><RichText setShowSpinner={setShowSpinner} /></TabPanel>

                    </TabContext>
                </Box>
            </div>
        </div>
    );
}

export default OrganizationFormUser;
